import ErrorArrow from "../../../assets/icons/error-arrow.svg";
import SuccessArrow from "../../../assets/icons/success-arrow.svg";
import s from "./QuizEnd.module.scss";
import { useEffect, useState } from "react";

import QuizLoader from "../QuizLoader/QuizLoader";
import QuizEndIcons from "./QuizEndIcons/QuizEndIcons";
import QuizEndLogos from "./QuizEndLogos/QuizEndLogos";

const base = window.post_template.checkout_v4_quiz;
const loaderDuration = base?.quiz_settings_loader_duration || 23000;
const headingDuration = base?.quiz_loader_heading_duration || 8000;
const paragraphDuration = base?.quiz_loader_paragraph_duration || 2000;
const brandName = window.general_settings?.brand_name || "Camtrix";
const discountUnlocked = base?.tr_quiz_loader_discount_unlocked_label || "Discount Unlocked";
const youQualifyFor = base?.tr_quiz_loader_you_qualify_for_label || "You qualify for";
const spanTextLabel = base?.tr_quiz_loader_span_text_label || "20% OFF";
const spanTextColor = base?.quiz_loader_span_text_color || "#27AE60";
const headMessages = base?.quiz_loader_header_messages;
const spanData = base?.quiz_loader_span_messages;

const headerMessages = [
  ...(headMessages?.length ? headMessages.map((msg) => msg?.tr_message) : []),
  <>
    {discountUnlocked} <br /> {youQualifyFor}{" "}
    <span style={{ color: `${spanTextColor}` }}>
      {spanTextLabel} {brandName}
    </span>
  </>,
];

const [flatSpanMessages, flatSpanArrows] =
  Array.isArray(spanData) && spanData.length > 0
    ? spanData.reduce(
        ([messages, arrows], item) => [
          [...messages, item?.tr_span_message || ""],
          [...arrows, item?.quiz_span_type ? SuccessArrow : ErrorArrow],
        ],
        [[], []]
      )
    : [[], []];

// Evenly distribute items into `groupCount` groups.
// Extra items go to the earliest groups (e.g., 10 over 4 -> 3,3,2,2)
const chunkEvenly = (arr, groupCount) => {
  if (!Number.isFinite(groupCount) || groupCount <= 0) return [];
  const total = arr.length;
  const base = Math.floor(total / groupCount);
  const remainder = total % groupCount;

  const groups = [];
  let idx = 0;

  for (let i = 0; i < groupCount; i++) {
    const size = base + (i < remainder ? 1 : 0);
    groups.push(arr.slice(idx, idx + size));
    idx += size;
  }

  return groups;
};

// ---- usage ----
const headerCount = headerMessages.length;
const spanMessages = chunkEvenly(flatSpanMessages, headerCount);
const spanArrows = chunkEvenly(flatSpanArrows, headerCount);

const QuizEnd = ({ onComplete }) => {
  const [headerIndex, setHeaderIndex] = useState(0);
  const [spanIndices, setSpanIndices] = useState([]);
  const [completed, setCompleted] = useState(false);

  useEffect(() => {
    if (completed) return;

    const headerTimeout = setTimeout(() => {
      setHeaderIndex((prevIndex) => {
        const nextIndex = prevIndex + 1;
        if (nextIndex < headerMessages.length) {
          setSpanIndices([]);
          return nextIndex;
        } else {
          setCompleted(true);
          onComplete();
          return prevIndex;
        }
      });
    }, headingDuration);

    return () => clearTimeout(headerTimeout);
  }, [headerIndex, completed]);

  useEffect(() => {
    if (completed) return;

    const spanTimeout = setTimeout(() => {
      setSpanIndices((prevIndices) => {
        const nextIndex = prevIndices.length;
        if (nextIndex < spanMessages[headerIndex].length) {
          return [...prevIndices, nextIndex];
        }
        return prevIndices;
      });
    }, paragraphDuration);

    return () => clearTimeout(spanTimeout);
  }, [spanIndices, headerIndex, completed]);

  return (
    <>
      <div className={s["endscreen"]}>
        <h1 className={`${s["endscreen__title"]} ${s["fade-in"]}`}>{headerMessages[headerIndex]}</h1>
        <QuizLoader totalDuration={loaderDuration} />
        <div className={`${s["endscreen__container"]} ${s["fade-in"]}`}>
          {spanIndices.map((index) => (
            <div key={index} className={`${s["endscreen__text-container"]} ${s["fade-in"]}`}>
              <img
                className={`${s["endscreen__icon"]} ${s["fade-in"]}`}
                src={spanArrows[headerIndex][index]}
                alt="Arrow Icon"
              />
              <p className={`${s["endscreen__paragraph"]} ${s["fade-in"]}`}>{spanMessages[headerIndex][index]}</p>
            </div>
          ))}
        </div>
      </div>
      <QuizEndIcons />
      <QuizEndLogos />
    </>
  );
};

export default QuizEnd;
